// extracted by mini-css-extract-plugin
module.exports = {"page":"page--24sLj","page_container":"page_container--2E0Yz","reco_banner":"reco_banner--3-COk","loading":"loading--HJc5N"};